import { Injectable, signal } from '@angular/core';
import { LayoutInfo } from '../models/model/concretes/components/layout-info.model';
import { Subscription } from '../models/model/concretes/shared/subcription.model';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  //#region Step
  private subscription = signal<Subscription | null>(null);
  private groupStep = signal(0);
  private step = signal(1);
  private stepIndex = signal(0);
  private stepShow = signal(3);
  private maxStep = signal(3);
  private maxStepShow = signal(3);
  private layoutInfo = signal<LayoutInfo | undefined>(undefined);
  private progress = signal(0);

  getSubscription() {
    return this.subscription;
  }

  setSubscription(data: Subscription | null) {
    this.subscription.set(data);
  }

  forceUpdateSubscription() {
    const currentSubscription = this.subscription();
    this.resetSubscription();
    this.subscription.set(currentSubscription);
  }

  resetSubscription() {
    this.subscription.set(null);
  }

  setGroupStep(data: number) {
    this.groupStep.set(data);
  }

  getGroupStep() {
    return this.groupStep;
  }

  nextGroupStep() {
    this.groupStep.update((groupStep) => groupStep + 1);
  }

  previousGroupStep() {
    this.groupStep.update((groupStep) => (groupStep > 0 ? groupStep - 1 : groupStep));
  }

  setStep(data: number) {
    this.step.set(data);
  }

  getStep() {
    return this.step;
  }

  setStepIndex(data: number) {
    this.stepIndex.set(data);
  }

  getStepIndex() {
    return this.stepIndex;
  }

  setStepShow(data: number) {
    this.stepShow.set(data);
  }

  getStepShow() {
    return this.stepShow;
  }

  nextStep() {
    this.step.update((step) => step + 1);
    this.stepIndex.update((step) => step + 1);
  }

  previousStep() {
    this.step.update((step) => (step > 1 ? step - 1 : step));
    this.stepIndex.update((step) => (step > 0 ? step - 1 : step));
  }

  setMaxStep(data: number) {
    this.maxStep.set(data);
  }

  getMaxStep() {
    return this.maxStep;
  }

  setMaxStepShow(data: number) {
    this.maxStepShow.set(data);
  }

  getMaxStepShow() {
    return this.maxStepShow;
  }

  setLayoutInfo(data: LayoutInfo) {
    this.layoutInfo.set(data);
  }

  getLayoutInfo() {
    return this.layoutInfo;
  }

  setProgress(data: number) {
    this.progress.set(data);
  }

  getProgress() {
    return this.progress;
  }
  //#endregion

  //#region Login
  isAuthenticated = signal(false);

  // Signals pour l'email et le mot de passe
  email = signal('');
  password = signal('');

  setEmail(newEmail: string): void {
    this.email.set(newEmail);
  }

  setPassword(newPassword: string): void {
    this.password.set(newPassword);
  }

  setAuthenticated(status: boolean): void {
    this.isAuthenticated.set(status);
  }
  //#endregion
}
